import { forwardRef } from 'react';

import type { DataTestId } from '../../core/types/data-props.js';
import type { StylingProps } from '../../core/types/styling-props.js';
import type { WithChildren } from '../../core/types/with-children.js';
import { Flex } from '../../layouts/flex/Flex.js';

//#region Typings
/**
 * Accepted properties for the HealthIndicator Visual.
 * @public
 */
export interface HealthIndicatorVisualProps
  extends WithChildren, StylingProps, DataTestId {}
//#endregion

/**
 * The HealthIndicator Visual component represents the custom visualization of the indicator.
 * @public
 */
export const Visual = forwardRef<HTMLDivElement, HealthIndicatorVisualProps>(
  (props, forwardedRef) => {
    const {
      children,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
      ...remainingProps
    }: HealthIndicatorVisualProps = props;

    return (
      <Flex
        data-testid={dataTestId}
        ref={forwardedRef}
        className={consumerClassName}
        style={consumerStyle}
        {...remainingProps}
      >
        {children}
      </Flex>
    );
  },
);

(Visual as typeof Visual & { displayName: string }).displayName =
  'HealthIndicator.Visual';
